import React, {Component} from 'react';
import './SelectSupplierModal.css'
import {Modal, OverlayTrigger} from "react-bootstrap";
import BackEnd from "../../../../backend/BackEnd";
import Dropdown from "../../../../controls/Dropdown";
import ActionLink from "../../../../controls/ActionLink";
import DateTimePicker from "../../../../controls/DateTimePicker";
import Pager from "../../../../controls/Pager";
import ContactsPopover from "./popovers/ContactsPopover";
import ProposedRatePopover from "./popovers/ProposedRatePopover";
import {errorToast, successToast} from "../../../../utils/toasts";
import RepeatSendPopover from "./popovers/RepeatSendPopover";
import ForceSelectPopover from "./popovers/ForceSelectPopover";
import debounce from 'lodash.debounce';

class SelectSupplierModal extends Component {
    static propTypes = {};
    static defaultProps = {
        pageSize: 10
    };
    state = {
        isFormLoading: false,
        isSuppliersLoading: false,
        tenderItem: {},
        addressDelivery: '',
        deliveryDate: '',
        margin: '',
        isMarginEditable: false,
        companyId: '',
        regionId: '',
        usedState: '',
        hasAgreedPrice: false,
        usedStates: [
            {id: '', text: '-- Любой тип поддонов --'},
            {id: 'Unspecified', text: 'Нет информации'},
            {id: 'New', text: 'Новые'},
            {id: 'Used', text: 'Б/У'},
            {id: 'Both', text: 'Новые и Б/У'}
        ],
        sentReminderEmails: [],
        isMassReminderEmailSent: false,
        suppliersIndex: [],
        allSuppliersSelected: false,
        selectedSuppliers: [],
        items: [],
        totalCount: 0,
        pageIndex: 0
    };
    contactsPopoverOverlay = [];
    proposedRatePopoverOverlay = [];
    repeatSendPopover = [];
    forceSelectPopover = [];
    searchCriteria = {};
    getFormData = new BackEnd.SupplierSelection.GetSelectProviderFormData({
        start: () => this.setState({isFormLoading: true}),
        end: () => this.setState({isFormLoading: false})
    });
    searchSuppliers = new BackEnd.SupplierSelection.SearchTenderSuppliers({
        start: () => this.setState({isSuppliersLoading: true}),
        end: () => this.setState({isSuppliersLoading: false})
    });
    getSuppliersIndex = new BackEnd.SupplierSelection.GetSuppliersIndex({
        start: () => this.setState({isSuppliersLoading: true}),
        end: () => this.setState({isSuppliersLoading: false})
    });

    async componentWillReceiveProps(nextProps) {
        if (!this.props.show && nextProps.show) {
            await this.fetchFormData();
            await this.search();

            const suppliersIndex = await this.getSuppliersIndex.call({
                tenderId: this.props.tenderId,
                dto: {
                    ...this.searchCriteria,
                    paging: {
                        pageIndex: this.state.pageIndex,
                        pageSize: this.props.pageSize
                    }
                }
            });

            this.setState({suppliersIndex});
        }
    }

    render() {
        const {tenderId, pageSize, ...props} = this.props;
        const loadingSpinner = <div className="text-center m-t-2">
            <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
        </div>;

        return (
            <Modal {...props} className="modal-xl" bsSize="large" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Выбор поставщика</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={`${this.state.isFormLoading ? 'form-loading' : ''}`}>
                        <form>
                            <div className="row">
                                <div className="col-xl-4">
                                    <fieldset className="form-group">
                                        <label>Адрес доставки</label>
                                        <input type="text" className="form-control"
                                               style={{resize: 'none'}}
                                               disabled={true}
                                               value={this.state.addressDelivery}/>
                                    </fieldset>
                                </div>
                                <div className="col-xl-3">
                                    <fieldset className="form-group">
                                        <label>Дата и время доставки</label>s
                                        <DateTimePicker className="form-control"
                                                        value={this.state.deliveryDate}
                                                        onChange={deliveryDate => this.updateDeliveryDate(deliveryDate)}/>
                                    </fieldset>
                                </div>
                                <div className="col-xl-2">
                                    <fieldset className="form-group">
                                        <label>Заданная маржа</label>
                                        <div className="input-group" style={{width: '110px'}}>
                                            <input type="number" className="form-control"
                                                   min="0"
                                                   disabled={!this.state.isMarginEditable}
                                                   value={this.state.margin}
                                                   onChange={event => this.updateMargin(event.target.value)}/>
                                            <span className="input-group-addon">%</span>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </form>
                        <div className="row">
                            <div className="col-sm-9">
                                <div className="row m-b-1">
                                    <div className="col-sm-4">
                                        <Dropdown className="form-control"
                                                  placeholder="Выберите поставщика"
                                                  dataSource={new BackEnd.SupplierSelection.SearchSuppliers()}
                                                  value={this.state.companyId}
                                                  onChange={event => this.updateSearchCriteria({companyId: event.target.value})}/>
                                    </div>
                                    <div className="col-sm-4">
                                        <Dropdown className="form-control"
                                                  placeholder="Выберите регион"
                                                  dataSource={new BackEnd.SupplierSelection.SearchRegions()}
                                                  value={this.state.regionId}
                                                  onChange={event => this.updateSearchCriteria({regionId: event.target.value})}/>
                                    </div>
                                    <div className="col-sm-4">
                                        <select className="form-control"
                                                value={this.state.usedState}
                                                onChange={event => this.updateSearchCriteria({usedState: event.target.value})}>
                                            {this.state.usedStates.map(item =>
                                                <option key={item.id} value={item.id}>{item.text}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <label className="custom-control custom-checkbox checkbox-inline">
                                            <input type="checkbox" className="custom-control-input"
                                                   checked={this.state.hasAgreedPrice}
                                                   onChange={event => this.updateSearchCriteria({hasAgreedPrice: event.target.checked})}/>
                                            <span className="custom-control-indicator"/> Отображать только поставщиков с согласованной ценой
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <button type="button" className="btn btn-default"
                                        onClick={() => this.resetFilters()}>
                                    Сбросить фильтры
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="pull-right">
                                    <Pager pageSize={this.props.pageSize}
                                           pageIndex={this.state.pageIndex}
                                           totalCount={this.state.totalCount}
                                           onChange={pageIndex => this.updatePageIndex(pageIndex)} />
                                </div>
                            </div>
                        </div>
                        {
                            !this.state.items.length && !this.state.isSuppliersLoading &&
                            <div className="row m-t-2">
                                <div className="col-md-12">
                                    <div className="alert alert-warning">
                                        <p>Для данных параметров поиска не найдено ни одного поставщика.</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            (!!this.state.items.length || this.state.isSuppliersLoading) &&
                            <div className="row">
                                <div className="col-md-12">
                                    {
                                        this.state.isSuppliersLoading
                                            ? loadingSpinner
                                            : <table className="table">
                                                <thead>
                                                <tr>
                                                    <th/>
                                                    <th/>
                                                    <th/>
                                                    <th/>
                                                    <th/>
                                                    <th/>
                                                    <th>
                                                        <div className="row">
                                                            <div className="col-sm-10">
                                                                <div>Тип</div>
                                                                <div>Количество</div>
                                                                <div>Ставка клиента</div>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div className="row">
                                                            <div className="col-sm-10">
                                                                <div>{this.state.tenderItem.code}</div>
                                                                <div>{this.state.tenderItem.count}</div>
                                                                <div>{this.state.tenderItem.sum}</div>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th/>
                                                    <th/>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <input type="checkbox"
                                                               checked={this.state.allSuppliersSelected}
                                                               onChange={event => this.selectAllSuppliers(event.target.checked)}/>
                                                    </th>
                                                    <th>Поставщик</th>
                                                    <th>Уровень<br/>сервиса</th>
                                                    <th>Тип</th>
                                                    <th>Регион</th>
                                                    <th>Тип поддонов</th>
                                                    <th>Предложенная ставка</th>
                                                    <th>Ответ поставщика</th>
                                                    <th>Статус</th>
                                                    <th/>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.items.map(item =>
                                                    <tr key={item.id}>
                                                        <td>
                                                            {
                                                                item.isAvailableSend &&
                                                                <input type="checkbox"
                                                                       checked={this.state.selectedSuppliers.indexOf(item.id) !== -1}
                                                                       onChange={event => this.selectSupplier(item, event.target.checked)}/>
                                                            }
                                                        </td>
                                                        <td>
                                                            <span>{item.name}</span>
                                                            <br/>
                                                            <div className="font-size-11 clearfix">
                                                                {
                                                                    !!item.contacts.length &&
                                                                    <OverlayTrigger
                                                                        ref={el => this.contactsPopoverOverlay[item.id] = el}
                                                                        trigger="click" placement="top"
                                                                        rootClose
                                                                        overlay={<ContactsPopover
                                                                            contacts={item.contacts}
                                                                            close={() => this.contactsPopoverOverlay[item.id].hide()}/>}>
                                                                        <ActionLink>Контакты</ActionLink>
                                                                    </OverlayTrigger>
                                                                }
                                                                {
                                                                    item.isDemo &&
                                                                    <div className="text-danger font-size-11 pull-right">
                                                                        Demo</div>
                                                                }
                                                            </div>
                                                        </td>
                                                        <td>{this.getServiceLevelIcon(item)}</td>
                                                        <td>{item.paymentType.text}</td>
                                                        <td>{item.region.map((region, i) => <div key={i}>{region}</div>)}</td>
                                                        <td>{this.getProductType(item)}</td>
                                                        <td>
                                                            <div>
                                                                <div>
                                                                    {
                                                                        item.isAvailableSend &&
                                                                        <OverlayTrigger
                                                                            ref={el => this.proposedRatePopoverOverlay[item.id] = el}
                                                                            trigger="click" placement="top"
                                                                            rootClose
                                                                            overlay={<ProposedRatePopover
                                                                                itemRate={item.orderItems[0].proposedRate}
                                                                                count={item.orderItems[0].count}
                                                                                onSave={itemRate => this.updateProposedRate(item, itemRate)}
                                                                                close={() => this.proposedRatePopoverOverlay[item.id].hide()}/>}>
                                                                            <ActionLink>
                                                                                {this.getProposedRate(item)}
                                                                            </ActionLink>
                                                                        </OverlayTrigger>
                                                                    }
                                                                    {
                                                                        !item.isAvailableSend &&
                                                                        this.getProposedRate(item)
                                                                    }
                                                                </div>
                                                                <small>
                                                                    Согласованная&nbsp;цена:
                                                                    {' '}
                                                                    <b>
                                                                        {item.orderItems[0].agreedPrice == null
                                                                            ? "Нет"
                                                                            : item.orderItems[0].agreedPrice.price.toLocaleString("ru-RU") + ' ' + (item.orderItems[0].agreedPrice.taxTypeId === 1 ? 'с НДС' : 'без НДС')}
                                                                    </b>
                                                                </small>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {
                                                                !!item.orderItems[0].providerRate &&
                                                                <div>
                                                                    {item.orderItems[0].providerRate} {item.orderItems[0].taxType}
                                                                </div>
                                                            }
                                                        </td>
                                                        <td>{item.state}</td>
                                                        <td>
                                                            {
                                                                item.isAvailableSend &&
                                                                <button type="button" className="btn btn-success btn-sm m-r-1 m-b-1"
                                                                        onClick={() => this.sendRequest(item)}>
                                                                    Отправить запрос
                                                                </button>
                                                            }
                                                            {
                                                                item.isAvailableSelect && !item.isDemo &&
                                                                <button type="button" className="btn btn-success btn-sm m-r-1 m-b-1"
                                                                        onClick={() => this.selectProvider(item)}>
                                                                    Выбрать
                                                                </button>
                                                            }
                                                            {
                                                                item.isAvailableResend &&
                                                                <OverlayTrigger
                                                                    ref={el => this.repeatSendPopover[item.id] = el}
                                                                    trigger="click" placement="top"
                                                                    rootClose
                                                                    overlay={<RepeatSendPopover
                                                                        item={item.orderItems[0]}
                                                                        onSave={rate => this.repeatSend(rate, item)}
                                                                        close={() => this.repeatSendPopover[item.id].hide()}/>}>
                                                                    <button type="button" className="btn btn-info btn-sm m-r-1 m-b-1">
                                                                        Отправить повторно
                                                                    </button>
                                                                </OverlayTrigger>
                                                            }
                                                            {
                                                                item.isAvailableForceSelect && !item.isDemo &&
                                                                <OverlayTrigger
                                                                    ref={el => this.forceSelectPopover[item.id] = el}
                                                                    trigger="click" placement="top"
                                                                    rootClose
                                                                    overlay={<ForceSelectPopover
                                                                        item={item.orderItems[0]}
                                                                        onSave={rate => this.selectSupplierForce(rate, item)}
                                                                        close={() => this.forceSelectPopover[item.id].hide()}/>}>
                                                                    <button type="button" className="btn btn-warning btn-sm m-r-1 m-b-1">
                                                                        Выбрать принудительно
                                                                    </button>
                                                                </OverlayTrigger>
                                                            }
                                                            {
                                                                item.isAvailableForceSelect &&
                                                                <button className={`btn btn-sm m-r-1 m-b-1 ${this.isReminderEmailSent(item) ? 'btn-success' : 'btn-default'}`}
                                                                        disabled={this.isReminderEmailSent(item)}
                                                                        onClick={() => this.sendReminderEmail(item)}>
                                                                    {/*css: {*/}
                                                                    {/*'btn-default': !$root.isReminderEmailSent(item),*/}
                                                                    {/*'btn-green': $root.isReminderEmailSent(item)*/}
                                                                    {/*}*/}
                                                                    <i className="fa fa-envelope"/>
                                                                </button>
                                                            }
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                    }
                                </div>
                            </div>
                        }
                        <div className="row m-t-1">
                            <div className="col-md-12">
                                <button className="btn btn-primary m-r-1"
                                        disabled={(!this.state.selectedSuppliers.length && !this.state.allSuppliersSelected) || this.state.isSuppliersLoading}
                                        onClick={() => this.sendMassRequest()}>
                                    {this.state.isSuppliersLoading && <span><i className="fa fa-circle-o-notch fa-spin"/> </span>}
                                    Отправить запрос выбранным поставщикам
                                    {
                                        !!this.state.selectedSuppliers.length &&
                                        ` (${this.state.selectedSuppliers.length})`
                                    }
                                </button>
                                <button className={`btn ${this.state.isMassReminderEmailSent ? 'btn-success' : 'btn-default'}`}
                                        disabled={this.state.isMassReminderEmailSent}
                                        onClick={() => this.sendMassReminderEmail()}>
                                    <i className="fa fa-envelope"/> Напомнить всем
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    async updatePageIndex(pageIndex) {
        this.setState({pageIndex});
        await this.search(this.searchCriteria, pageIndex);
    }

    async fetchFormData() {
        const {tenderId} = this.props;

        let formData = await this.getFormData.call({tenderId});
        this.setState({
            tenderItem: formData.items[0],
            addressDelivery: formData.addressDelivery,
            deliveryDate: formData.deliveryDate,
            margin: formData.margePercent,
            isMarginEditable: formData.isMarginEditable
        });
    }

    async search(criteria = this.searchCriteria, pageIndex = this.state.pageIndex) {
        this.searchCriteria = criteria;

        const result = await this.searchSuppliers.call({
            tenderId: this.props.tenderId,
            dto: {
                ...criteria,
                paging: {
                    pageIndex: pageIndex,
                    pageSize: this.props.pageSize
                }
            }
        });

        this.setState(result);
    }

    async updateDeliveryDate(deliveryDate) {
        this.setState({deliveryDate});
        let updateField = new BackEnd.SupplierSelection.UpdateField();
        let result = await updateField.call({
            tenderId: this.props.tenderId,
            fieldName: 'deliveryDate',
            value: deliveryDate
        });

        if (result.success) {

        }
    }

    updateMarginDebounced = debounce(async () => {
        const updateField = new BackEnd.SupplierSelection.UpdateField({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });

        const result = await updateField.call({
            tenderId: this.props.tenderId,
            fieldName: 'margePercent',
            value: this.state.margin
        });

        if (result.success) {
            await this.search();
        }
    }, 750);

    updateMargin(margin) {
        this.setState({margin}, () => this.updateMarginDebounced());
    }

    async updateSearchCriteria(criteria) {
        const {companyId, regionId, usedState, hasAgreedPrice} = this.state;

        this.setState(criteria);
        this.searchCriteria = {
            companyId,
            regionId,
            usedState,
            hasAgreedPrice,
            ...criteria
        };

        await this.search(this.searchCriteria)
    }

    async resetFilters() {
        await this.updateSearchCriteria({
            companyId: null,
            regionId: null,
            usedState: '',
            hasAgreedPrice: false
        });
    }

    selectAllSuppliers(flag) {
        if (flag) {
            this.setState({
                allSuppliersSelected: flag,
                selectedSuppliers: [...this.state.suppliersIndex]
            });
        }
        else {
            this.setState({
                allSuppliersSelected: flag,
                selectedSuppliers: []
            });
        }
    }

    selectSupplier(supplierItem, flag) {
        const {selectedSuppliers} = this.state;

        if (flag) {
            selectedSuppliers.push(supplierItem.id);
            this.setState({
                selectedSuppliers
            });
        }
        else {
            selectedSuppliers.splice(selectedSuppliers.indexOf(supplierItem.id), 1);
            this.setState({
                allSuppliersSelected: false,
                selectedSuppliers
            });
        }
    }

    async sendMassRequest() {
        const sendMassRequestEndpoint = new BackEnd.SupplierSelection.SendMassRequest({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });
        const result = await sendMassRequestEndpoint.call({
            tenderId: this.props.tenderId,
            dto: {
                searchForm: {
                    companyId: this.state.contractorId,
                    regionId: this.state.regionId,
                    usedState: this.state.usedState,
                    hasAgreedPrice: this.state.hasAgreedPrice
                },
                selectedSuppliers: this.state.selectedSuppliers
            }
        });

        if (result.success) {
            successToast("Запрос успешно отправлен выбранным поставщикам");
        }

        await this.fetchFormData();
        await this.search();
    }

    async sendMassReminderEmail() {
        if (this.state.isMassReminderEmailSent)
            return;

        const sendMassReminderEmailEndpoint = new BackEnd.SupplierSelection.SendMassReminderEmail({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });
        const result = await sendMassReminderEmailEndpoint.call({
            tenderId: this.props.tenderId
        });

        if (result.success) {
            successToast("Письмо-напоминание успешно отправлено");
            this.setState({isMassReminderEmailSent: true});
        }
    }

    getServiceLevelIcon(supplierItem) {
        switch (supplierItem.serviceLevel.id) {
            case 1:
                return (
                    <span>
                        <i className="fa fa-star"/><i className="fa fa-star"/><i className="fa fa-star"/>
                    </span>
                );
            case 2:
                return (
                    <span>
                        <i className="fa fa-star"/><i className="fa fa-star"/><i className="fa fa-star-o"/>
                    </span>
                );
            case 3:
                return (
                    <span>
                        <i className="fa fa-star"/><i className="fa fa-star-o"/><i className="fa fa-star-o"/>
                    </span>
                );
            default:
                return 'Нет информации';
        }
    }

    getProductType(supplierItem) {
        if (supplierItem.isProviderOfUsed && !supplierItem.isProviderOfNew)
            return 'Б/У';

        if (supplierItem.isProviderOfNew && !supplierItem.isProviderOfUsed)
            return 'Новые';

        if (supplierItem.isProviderOfNew && supplierItem.isProviderOfUsed)
            return 'Новые и Б/У';

        return 'Нет информации';
    }

    getProposedRate(supplierItem) {
        let supplierItemItem = supplierItem.orderItems[0];
        let totalProposedRate = (supplierItemItem.proposedRate * supplierItemItem.count).toLocaleString("ru-RU");
        let itemProposedRate = supplierItemItem.proposedRate.toLocaleString("ru-RU", {maximumFractionDigits: 2});

        return `${totalProposedRate} / ${itemProposedRate} р.`
    }

    async updateProposedRate(supplierItem, proposedRate) {
        let setProposedRate = new BackEnd.SupplierSelection.SetProposedRate();
        let result = await setProposedRate.call({
            providerCandidatOrderItemId: supplierItem.orderItems[0].providerCandidatOrderItemId,
            proposedRate
        });

        await this.search();
    }

    async sendRequest(supplierItem) {
        let sendRequestEndpoint = new BackEnd.SupplierSelection.SendRequest({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });
        let result = await sendRequestEndpoint.call({
            providerCandidatId: supplierItem.id
        });

        await this.fetchFormData();
        await this.search();
    }

    async selectProvider(item) {
        const {onHide} = this.props;

        let selectProviderEndpoint = new BackEnd.SupplierSelection.SelectSupplier({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });
        let result = selectProviderEndpoint.call({
            tenderRequestId: item.id
        });

        onHide();
    }

    async repeatSend(rate, supplierItem) {
        let repeatSendRequest = new BackEnd.SupplierSelection.RepeatSendRequest({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });
        let result = await repeatSendRequest.call({
            tenderRequestId: supplierItem.id,
            items: [{
                proposedRate: rate,
                articleUid: supplierItem.orderItems[0].articleUid
            }]
        });

        await this.search();
    }

    async selectSupplierForce(rate, supplierItem) {
        const {onHide} = this.props;

        let forceSelectProvider = new BackEnd.SupplierSelection.ForceSelectSupplier({
            start: () => this.setState({isFormLoading: true}),
            end: () => this.setState({isFormLoading: false})
        });
        let result = await forceSelectProvider.call({
            tenderRequestId: supplierItem.id,
            items: [{
                proposedRate: rate,
                articleUid: supplierItem.orderItems[0].articleUid
            }]
        });

        if (result.success) {
            onHide();
        } else if (result.errorMessage) {
            errorToast(result.errorMessage);
        }
    }

    isReminderEmailSent(item) {
        const {sentReminderEmails, isMassReminderEmailSent} = this.state;

        return item.type === "TenderRequest" &&
            sentReminderEmails.indexOf(item.id) !== -1 ||
            isMassReminderEmailSent;
    }

    async sendReminderEmail(item) {
        if (this.isReminderEmailSent(item))
            return;

        if (item.type === "TenderRequest") {
            const {sentReminderEmails} = this.state;

            let sendReminderEmailEndpoint = new BackEnd.SupplierSelection.SendReminderEmail({
                start: () => this.setState({isFormLoading: true}),
                end: () => this.setState({isFormLoading: false})
            });
            let result = await sendReminderEmailEndpoint.call({
                tenderRequestId: item.id
            });

            if (result.success) {
                successToast("Письмо-напоминание успешно отправлено");
                sentReminderEmails.push(item.id);
                this.setState({sentReminderEmails});
            }
        }
    }
}

export default SelectSupplierModal;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/modals/SelectSupplierModal.js